import GRADE_DATA from '#app/data/grades.json'

export const findGradeName = (
	level: number,
	line: number,
	baseBranchLevel: number,
	targetLevel: number,
	targetType: string,
) => {
	if (line === 1) {
		return GRADE_DATA.find(
			gd => gd.line === 1 && gd.level === level,
		)?.grades.find(g => g.level === targetLevel && g.type === targetType)?.name
	}
	if (line === 2) {
		return GRADE_DATA.find(
			gd =>
				gd.line === 2 &&
				gd.level === level &&
				gd.baseBranchLevel === baseBranchLevel,
		)?.grades.find(g => g.level === targetLevel && g.type === targetType)?.name
	}
	throw new Error('Invalid line : ' + line)
}

export const findVerticalGrades = (level: number) => {
	const grades = GRADE_DATA.find(
		gd => gd.line === 1 && gd.level === level,
	)?.grades.sort((a, b) => b.level - a.level)
	return grades ?? []
}

export const findBranchedGrades = (level: number, baseBranchLevel: number) => {
	const grades = GRADE_DATA.find(
		gd =>
			gd.line === 2 &&
			gd.level === level &&
			gd.baseBranchLevel === baseBranchLevel,
	)?.grades.sort((a, b) => b.level - a.level)
	return grades ?? []
}

const defaultBaseBranchLevels = [
	{ level: 2, baseBranchLevel: 2 },
	{ level: 3, baseBranchLevel: 3 },
	{ level: 4, baseBranchLevel: 4 },
	{ level: 5, baseBranchLevel: 4 },
	{ level: 6, baseBranchLevel: 5 },
	{ level: 7, baseBranchLevel: 5 },
	{ level: 8, baseBranchLevel: 5 },
	{ level: 9, baseBranchLevel: 6 },
	{ level: 10, baseBranchLevel: 6 },
]
export const findDefaultBranchedGrades = (level: number) => {
	const found = defaultBaseBranchLevels.find(item => item.level === level)
	if (!found) {
		throw new Error('Not found defaultBaseBranchLevel')
	}
	return findBranchedGrades(level, found.baseBranchLevel)
}

export const findGradeBySalary = (
	salary: number,
	gradeRankSalarySettings: { salary: number; grade: any }[],
) => {
	let grade: any = null

	for (let i = 0; i < gradeRankSalarySettings.length - 1; i++) {
		const current = gradeRankSalarySettings[i]
		const next = gradeRankSalarySettings[i + 1]

		if (current.salary <= salary && salary < next.salary) {
			grade = current.grade
			break
		}
	}

	// Check if the salary is greater than or equal to the last element's salary
	if (
		salary >= gradeRankSalarySettings[gradeRankSalarySettings.length - 1].salary
	) {
		grade = gradeRankSalarySettings[gradeRankSalarySettings.length - 1].grade
	}
	// マッチするものがなかった場合、強制的に最初の等級にする
	if (!grade) {
		grade = gradeRankSalarySettings[gradeRankSalarySettings.length - 1].grade
	}

	return grade
}

export function matchGradePattern(
	gradeSetting: {
		gradeLevel: number
		gradeBaseBranchLevel: number
		gradeLine: number
	},
	grades: { level: number; type: string }[],
) {
	const { gradeLevel, gradeBaseBranchLevel, gradeLine } = gradeSetting
	// 垂直型の場合は等級レベルと等級データの長さが一致すれば良い
	if (gradeLine === 1) {
		return gradeLevel === grades.length
	}
	// 分岐型の場合は各タイプの等級データの長さをチェック
	const generalCount = gradeBaseBranchLevel - 1
	const managerCount = gradeLevel - generalCount
	const specialistCount = managerCount

	const generals = grades.filter(grade => grade.type === 'general')
	const managers = grades.filter(grade => grade.type === 'manager')
	const specialists = grades.filter(grade => grade.type === 'specialist')

	return (
		generalCount === generals.length &&
		managerCount === managers.length &&
		specialistCount === specialists.length
	)
}
